module.exports = __webpack_public_path__ + "static/media/greenCircle.8cef7e56.svg";